import axios from '../axios';

const fetchUser = async () => {
  const { data } = await axios.get('/auth/me');

  return data;
};

export default fetchUser;
